'use client';
import { cn } from '@/lib/utils';
import { forwardRef, HTMLAttributes } from 'react';
import styles from './subheading.module.scss';

export type SubheadingProps = {
  size?: string;
  content?: string;
  color?: string;
  textAlign?: string;
} & HTMLAttributes<HTMLHeadingElement>;

export const Subheading = forwardRef<HTMLHeadingElement, SubheadingProps>(
  ({ size, content = '', color, textAlign, ...props }, ref) => {
    return (
      <strong ref={ref} className={cn(size, color, textAlign, styles.subheading)} {...props}>
        {content}
      </strong>
    );
  },
);

Subheading.displayName = 'Subheading';
